<template>
  <div id="mySupersuProList">
    <div>
      <div class="allDl m_t_20 d_flex" style="position:relative">
        <dl class="allDl_width30 allDl_span60" style="width: 80%;">
          <dd>
            <span>人员组:</span>
            <div>
              <input v-model="postData.groupName" type="text" class="allInput"/>
            </div>
          </dd>
          <dt style="width: auto;">
            <button @click="getAllSerch()" class="suerButton"><i class="icon iconfont iconsousuo" style="font-size: 14px"></i><span class="m_l_5">搜索</span></button>
          </dt>
        </dl>
        <div>
          <button @click="addNewList()" class="addButton"><i class="el-icon-plus"></i><span class="m_l_5">新建</span></button>
        </div>
      </div>
      <div style="max-height: calc(100vh - 270px);overflow: auto">
        <table class="allTable" cellspacing="0">
          <thead>
          <tr>
            <!--<th style="text-align: left">ID</th>-->
            <th>人员组</th>
            <th>描述</th>
            <th>最近更新时间</th>
            <th>最近更新人</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myAllList">
            <!--<td style="text-align: left">{{item.id}}</td>-->
            <td>{{ item.name }}</td>
            <td>{{ item.describe}}</td>
            <td>{{ $commonJs.returnDate(item.lastModifyTime, 'YYMMDD') }}</td>
            <td>{{ item.lastModifyName }}</td>
            <td class="colorYellowF36A20" width="60">
              <div class="d_flex">
                <span class="c_p" @click="toUrl(item)">编辑</span>
                <span @click="allDelt(item)" class="colorDele c_p">删除</span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <page :totalCount="totalCount" v-if="totalPage !== 0" v-on:on-getList="getAllList($event)" :totalPage="totalPage" :page="page" :numPage="1"></page>
    </div>
    <model v-if="showModel" :title="'新建人员组'" :minWidth="'400px'" :onButton="1" v-on:on-cancel="showModel = false" v-on:on-confirm="addConfirm()">
      <div class="pd_10_20">
        <div class="allDl m_t_20">
          <dl class="allDl_width100 allDl_span60">
            <dd>
              <span>人员组:</span>
              <div>
                <input v-model="myNewData.name" type="text" class="allInput" placeholder="请输入"/>
              </div>
            </dd>
            <dd>
              <span style="vertical-align: top">描述:</span>
              <div>
                <textarea v-model="myNewData.describe" class="allTextarea" rows="5" style="vertical-align: top;width: calc(100% - 12px)" placeholder="请输入"></textarea>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'mySupersuProList',
  data () {
    return {
      showModel: false,
      totalPage: 0,
      totalCount: 0,
      page: 1,
      postData: {
        groupName: '',
        pageIndex: 1,
        pageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      serchData: {
        groupName: '',
        pageIndex: 1,
        pageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      myAllList: [],
      myNewData: {
        id: 0,
        name: '',
        describe: ''
      },
      superId: 0
    }
  },
  created () {
    this.$commonJs.addLog('查看', '系统管理', '权限配置', '')
    this.getAllList(1)
  },
  mounted () {
  },
  methods: {
    getAllSerch () {
      this.serchData = JSON.parse(JSON.stringify(this.postData))
      this.getAllList(1)
    },
    getAllList (page) {
      let data = JSON.parse(JSON.stringify(this.serchData))
      if (this.serchData.groupName === '') {
        delete data['groupName']
      }
      data.pageIndex = page
      let url = this.$commonJs.returnQuery('/api/Role/GetAllRoles', data)
      this.$axiox.get(url).then(msg => {
        this.myAllList = msg.datas || []
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.serchData.pageSize)
        this.totalCount = msg.total
      })
    },
    addNewList () {
      this.showModel = true
    },
    addConfirm () {
      if (this.myNewData.name === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请输入人员组',
          stayTime: 5
        })
        return
      }
      this.$axiox.post('/api/Role/AddRole', this.myNewData).then(msg => {
        console.log(msg)
        this.$commonJs.addLog('新建', '系统管理', '权限配置', this.myNewData.name)
        this.superId = msg.data
        if (parseInt(this.superId) > 0) {
          this.$nextTick(p => {
            this.toUrl()
          })
        }
      })
    },
    toUrl (item) {
      if (item && item.id) {
        this.$commonJs.addLog('更新', '系统管理', '权限配置', item.name)
      }
      this.$router.push({
        name: 'mySupersuPro',
        query: {
          formId: (item && item.id) || this.superId
        }
      })
    },
    allDelt (item) {
      this.$commonJs.doubleComfirm({
        content: '是否删除该人员组？',
        successFun: msg => {
          this.$commonJs.addLog('删除', '系统管理', '权限配置', item.name)
          this.$axiox.get('/api/Role/DeleteRole?groupid=' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getAllList(this.page)
          })
        },
        errorFun: msg => {
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/mySystemMessager/mySupersuProList.vue